import React from "react";
import { Redirect } from "react-router-dom";
import { MainLayout } from "./MainLayout";
import validateToken from "src/helpers/validateToken";
import { connect } from "react-redux";
import * as Logged from "src/redux/logged";
import { AppState } from "src/redux/store";
import * as Stories from "src/redux/stories";
import { setAuthToken } from "src/plugins/axiosInstance";
import { toast } from "react-toastify";
import i18next from "../plugins/i18nextPlugin";
import { Loader } from "./Loader";
/**
 * Default app layout
 * Wraps the given react component between a header and a footer
 */

function mapStateToProps(state: AppState) {
  return {
    logged: state.logged
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setLogged: (logged: boolean) => dispatch(Logged.setLogged(logged)),
    init: () => dispatch(Stories.init())
  };
}
interface State {
  loader: boolean;
}
class ProtectedRoutesToConnect extends React.Component<any, State> {
  state: State = {
    loader: true
  };
  async componentWillMount() {
    // retrieve params in url
    const urlParams = new URLSearchParams(this.props.location.search);
    // search token in url params
    const tokenUrl = urlParams.get("token");
    // Save in storage local if token exist
    if (tokenUrl) {
      localStorage.setItem("authToken", tokenUrl);
    }
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      this.setState({
        loader: false
      });
      return;
    }
    if (!this.props.logged.logged) {
      await this.initStore(authToken);
      this.setState({
        loader: false
      });
    }
    return;
  }
  initStore = async token => {
    setAuthToken(token);
    try {
      await this.props.init();
    } catch (error) {
      toast.error(i18next.t("error.unknown"));
    }
    this.props.setLogged(true);
  };
  render() {
    const authToken = localStorage.getItem("authToken");
    const { component: Component, ...rest } = this.props as any;
    const { path } = rest;
    if (this.state.loader) {
      return <Loader />;
    }
    if (!authToken || !validateToken(authToken)) {
      return <Redirect exact={true} to="/login" />;
    }

    return <MainLayout exact={true} path={path} component={Component} />;
  }
}
// Pas besoin de typer car Router gère les props à notre place
export const ProtectedRoutes = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtectedRoutesToConnect);



// WEBPACK FOOTER //
// ./src/components/ProtectedRoutes.tsx